import axios from 'axios';
import { browserHistory } from '@browserHistory';

export function fetchAllRules(data) {
    return dispatch => {
        let response = axios.post('/api/ruleEngine/fetchAllRules', data);
        response.then(function () {
        }, function (error) {
            if (error.response !== undefined && error.response.status !== undefined && error.response.status === 401) {
                browserHistory.push('/login');
            }
        });
        return response;
    };
}

export function createUpdateRule(data) {
    return dispatch => {
        let response = axios.post('/api/ruleEngine/createUpdateRule', data);
        response.then(function () {
        }, function (error) {
            if (error.response !== undefined && error.response.status !== undefined && error.response.status === 401) {
                browserHistory.push('/login');
            }
        });
        return response;
    };
}

export function testRule(data) {
    return dispatch => {
        let response = axios.post('/api/ruleEngine/testRule', data);
        response.then(function () {
        }, function (error) {
            if (error.response !== undefined && error.response.status !== undefined && error.response.status === 401) {
                browserHistory.push('/login');
            }
        });
        return response;
    };
}

export function fetchRulById(data) {
    return dispatch => {
        let response = axios.post('/api/ruleEngine/fetchRuleById', data);
        response.then(function () {
        }, function (error) {
            if (error.response !== undefined && error.response.status !== undefined && error.response.status === 401) {
                browserHistory.push('/login');
            }
        });
        return response;
    };
}